/* Atelier — final call: set buttons switch the bottles cutout, the Add to bag variant and price.
   Kept in sync with the product above through the document event "atelier:variant-change". */
if (!customElements.get('atelier-final-cta')) {
  customElements.define(
    'atelier-final-cta',
    class AtelierFinalCta extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.productId = String(this.dataset.productId || '');
        this.addEventListener('click', (event) => {
          const shop = event.target.closest('[data-at-shop-top]');
          if (shop) {
            event.preventDefault();
            // back to the set picker: the product section's top, below a sticky header if there is one
            const target = document.querySelector('atelier-product');
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            let top = 0;
            if (target) {
              const header = document.querySelector('sticky-header, .shopify-section-header-sticky, .at-header');
              const stuck = header && getComputedStyle(header.closest('.shopify-section') || header).position === 'sticky';
              top = target.getBoundingClientRect().top + window.scrollY - (stuck ? header.offsetHeight : 0);
            }
            window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
            return;
          }
          const button = event.target.closest('.at-fcta__set[data-variant-id]');
          if (!button || !this.contains(button)) return;
          if (this.apply(button.dataset.variantId)) {
            document.dispatchEvent(
              new CustomEvent('atelier:variant-change', {
                detail: { productId: this.productId, variantId: button.dataset.variantId, source: this },
              })
            );
          }
        });
        this.onExternalChange = (event) => {
          const detail = event.detail || {};
          if (detail.source === this || String(detail.productId) !== this.productId) return;
          this.apply(detail.variantId);
        };
        document.addEventListener('atelier:variant-change', this.onExternalChange);
        this.addEventListener('shopify:block:select', (event) => {
          const button = event.target.closest && event.target.closest('[data-variant-id]');
          if (button) this.apply(button.dataset.variantId);
        });
      }

      disconnectedCallback() {
        if (this.onExternalChange) document.removeEventListener('atelier:variant-change', this.onExternalChange);
      }

      apply(variantId) {
        const id = String(variantId);
        const buttons = Array.from(this.querySelectorAll('.at-fcta__set[data-variant-id]'));
        const button = buttons.find((item) => item.dataset.variantId === id);
        if (!button) return false;
        buttons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
        this.querySelectorAll('[data-pack]').forEach((pack) => {
          pack.hidden = pack.dataset.pack !== id;
        });
        const input = this.querySelector('form input[name="id"]');
        if (input && input.value !== id) {
          input.value = id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const available = button.dataset.available === 'true';
        const submit = this.querySelector('form [type="submit"]');
        if (submit) {
          submit.disabled = !available;
          if (available) submit.removeAttribute('aria-disabled');
        }
        const label = this.querySelector('form .at-btn__label');
        if (label) label.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        const price = this.querySelector('form .at-btn__price');
        if (price) price.textContent = button.dataset.price || '';
        return true;
      }
    }
  );
}
